import { PageContent } from '@reapitform/dashboard-ui'
import { elPy9, Table, TTableRowAction } from '@reapitform/common-ui'
import { linkTableConfig } from './link-table-config'
import { useState } from 'react'
import { FlexContainer, TextBase } from '@reapit/elements'
import { useDefaultsLink } from '../../../../api/defaults/links/get'
import { IDefaultLink } from '../../../../api/types'
import { AddLinkModal } from './modal/add-link'
import { UpdateLinkModal } from './modal/update-link'
import { LinkDeleteConfirmationModal } from './modal/delete-confirmation'
import { useSearchParams } from 'react-router-dom'

export const LinkTabContent: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [isOpenDeleteConfirmation, setIsOpenDeleteConfirmation] = useState<boolean>(false)
  const [isOpenUpdateFormModal, setIsOpenUpdateFormModal] = useState<boolean>(false)
  const [isOpenAddFormModal, setIsOpenAddFormModal] = useState<boolean>(false)
  const [selectedData, setSelectedData] = useState<IDefaultLink>()
  const { data, loading, errorString, updateCacheData } = useDefaultsLink({
    sortBy: searchParams.get('sortBy'),
    sortByDirection: searchParams.get('sortByDirection'),
  })

  const handleSortChanges = (key: string, order: 'asc' | 'desc') => {
    setSearchParams((params) => {
      params.set('sortBy', key)
      params.set('sortByDirection', order === 'asc' ? 'Ascending' : 'Descending')
      return params
    })
  }

  const rowActions: TTableRowAction<IDefaultLink>[] = [
    {
      actionTitle: 'Edit',
      onClick: (data) => {
        setSelectedData(data)
        setIsOpenUpdateFormModal(true)
      },
    },
    {
      actionTitle: 'Delete',
      onClick: (data) => {
        setSelectedData(data)
        setIsOpenDeleteConfirmation(true)
      },
    },
  ]

  return (
    <PageContent className={elPy9}>
      <FlexContainer isFlexColumn>
        <TextBase hasSectionMargin>{linkTableConfig.description}</TextBase>
        <Table
          headers={linkTableConfig.header}
          rows={data}
          isLoading={loading}
          rowKeyIdentifier="id"
          errorMessage={errorString}
          emptyMessage={linkTableConfig.emptyMessages}
          tableDataCountMessage={linkTableConfig.countDisplay}
          onReorder={handleSortChanges}
          tableRowAction={rowActions}
          tableAction={{
            actionTitle: 'Add New',
            onClick: () => {
              setIsOpenAddFormModal(true)
            },
          }}
        />
      </FlexContainer>
      <AddLinkModal
        isOpen={isOpenAddFormModal}
        onOpenChange={(isOpen) => setIsOpenAddFormModal(isOpen)}
        refreshList={updateCacheData}
      />
      <UpdateLinkModal
        defaultValues={selectedData}
        isOpen={isOpenUpdateFormModal}
        onOpenChange={(isOpen) => setIsOpenUpdateFormModal(isOpen)}
        refreshList={updateCacheData}
      />
      <LinkDeleteConfirmationModal
        data={selectedData}
        isOpen={isOpenDeleteConfirmation}
        onOpenChange={(isOpen) => setIsOpenDeleteConfirmation(isOpen)}
        refreshList={updateCacheData}
      />
    </PageContent>
  )
}
